module.exports = __webpack_public_path__ + "static/media/gallery-wide-1.f8fc2e8c.jpg";